import { Button, ButtonGroup } from 'react-bootstrap';

import { AUTOMATA_LEVEL_3, AUTOMATA_LEVEL_4, AUTOMATA_OFF } from '../../../constants.ts';
import { IVehicle } from '../../../schema/Vehicle.ts';
import { getAutomataOffButtonColor } from '../../../utils/fleetUtils.ts';
import { VehicleMutationType } from './Vehicle.tsx';

export function AutomataLevel(props: Readonly<{ mutation: VehicleMutationType; vehicle: IVehicle }>) {
  return (
    <>
      <ButtonGroup className={'basic-shadow rounded-start-4 rounded-end-4'}>
        <Button
          className={'rounded-start-4 automata-button'}
          onClick={() => props.mutation.mutate({ automata_state: AUTOMATA_OFF })}
          variant={getAutomataOffButtonColor(props.vehicle)}
          active={props.vehicle.automata_state === AUTOMATA_OFF}>
          off
        </Button>
        <Button
          className={'automata-button'}
          onClick={() => props.mutation.mutate({ automata_state: AUTOMATA_LEVEL_3 })}
          active={props.vehicle.automata_state === AUTOMATA_LEVEL_3}>
          3
        </Button>
        <Button
          className={'rounded-end-4 automata-button'}
          onClick={() => props.mutation.mutate({ automata_state: AUTOMATA_LEVEL_4 })}
          active={props.vehicle.automata_state === AUTOMATA_LEVEL_4}>
          4
        </Button>
      </ButtonGroup>
    </>
  );
}
